import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, Output, EventEmitter, SimpleChanges, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { GlobalService } from 'src/app/shared/services/global.service';
import { TYPE_TABLE } from 'src/app/timeline/timeline.interface';
import { TimelineService } from 'src/app/timeline/timeline.service';

@Component({
    selector: 'app-timeline-table',
    templateUrl: './timeline-table.component.html',
    styleUrls: ['./timeline-table.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TimelineTableComponent implements OnInit {

	@Input() projects: any;
	@Input() weeks: any[] = [];
	@Input() days: any[] = [];
	@Input() months: any[] = [];
	@Input() years: any[] = [];
	@Input() type: TYPE_TABLE = TYPE_TABLE.Daily
	@Input() isMainPage: boolean = true;
	@Input() phasesProject: any[];
	@Output() contextChapterTask = new EventEmitter<any>();
	@Output() contextTask = new EventEmitter<any>();
	@Output() onPaginationTable = new EventEmitter<string>();
	readonly BOX_SIZE = 25;
	readonly TYPE_TABLE = TYPE_TABLE;
	unitSize = 25;
	viewboxHeader: string;
	viewboxHeaderHeight: number = 75;
	viewboxTable: string;
	viewboxTableWidth: number;
	viewboxTableHeight: number = 1000;
	loading: boolean = false;
	lastYPosition: number = 0;
	todayInfoDay: any;

	calculateViewBox() {
		this.viewboxTableHeight = this.lastYPosition + this.BOX_SIZE + 1;

		switch (this.type) {
			case TYPE_TABLE.Daily:
				this.viewboxHeaderHeight = 75;
				this.unitSize = 20;
				break;
			case TYPE_TABLE.Weekly:
				this.viewboxHeaderHeight = 75;
				this.unitSize = 6;
				break;
			case TYPE_TABLE.Monthly:
				this.viewboxHeaderHeight = 50;
				this.unitSize = 3;
				break;
		}

		this.viewboxTableWidth = (this.days.length * this.unitSize) + 1;
		this.viewboxTable = "0 0 " + this.viewboxTableWidth + " " + this.viewboxTableHeight;
		this.viewboxHeader = "0 0 " + this.viewboxTableWidth + " " + this.viewboxHeaderHeight;
	}

	calculateY() {
		if (this.isMainPage) {
			let position = this.projects[0] ? this.projects[0].isOpen ? this.BOX_SIZE : 0 : 0;
			let i = 0;
			for (const project of this.projects) {
				var SIZE = project.isOpen ? this.BOX_SIZE : this.BOX_SIZE / 2;
				if (i != 0) position += SIZE * 2;
				if (!project.phases_project.length) {
					position += project.isOpen ? 0 : SIZE * 2;
				}
				for (const phase of project.phases_project) {
					phase.positionY = position + SIZE;
					position += phase.tasks.length && project.isOpen && phase.isOpen ? (SIZE * phase.tasks.length) + SIZE : SIZE;
					let taskposition = SIZE;
					for (const task of phase.tasks) {
						task.positionY = taskposition;
						taskposition += SIZE;
					}
				}
				if (project.phases_project.length == 1) {
					position += project.isOpen ? 0 : SIZE;
				}
				i++;
			}
			this.lastYPosition = position;
		}
		else {
			let position = -25;
			if (this.phasesProject.length <= 0)
				position = 0;
			let i = 0;
			for (const project of this.projects) {
				var SIZE = project.isOpen ? this.BOX_SIZE : this.BOX_SIZE / 2;
				if (i != 0) position += SIZE;
				if (!project.phases_project.length) {
					position += project.isOpen ? 0 : SIZE * 2;
				}
				for (const phase of project.phases_project) {
					phase.positionY = position + SIZE;
					position += phase.tasks.length && project.isOpen && phase.isOpen ? (SIZE * phase.tasks.length) + SIZE : SIZE;
					let taskposition = SIZE;
					for (const task of phase.tasks) {
						task.positionY = taskposition;
						taskposition += SIZE;
					}
				}
				if (project.phases_project.length == 1) {
					position += project.isOpen ? 0 : SIZE;
				}
				i++;
			}
			this.lastYPosition = position;
		}
	}

	calculateYHeader() {
		this.days.map(d => {
			d.positionY = this.getPositionYHeaderElement('day');
			d.positionYText = this.getPositionYHeaderElement('day', true);
		});
		this.weeks.map(w => {
			w.positionY = this.getPositionYHeaderElement('week');
			w.positionYText = this.getPositionYHeaderElement('week', true);
		});
		this.months.map(m => {
			m.positionY = this.getPositionYHeaderElement('month');
			m.positionYText = this.getPositionYHeaderElement('month', true);
		});
		this.years.map(y => {
			y.positionY = this.getPositionYHeaderElement('year');
			y.positionYText = this.getPositionYHeaderElement('year', true);
		});
	}

	getPositionYHeaderElement(part, isText = false) {
		switch (part) {
			case 'year':
				if (this.type == TYPE_TABLE.Weekly) {
					return isText ? this.BOX_SIZE / 2 : 0;
				} else if (this.type == TYPE_TABLE.Monthly) {
					return isText ? this.BOX_SIZE / 2 : 0;
				}
				break;
			case 'month':
				if (this.type == TYPE_TABLE.Daily) {
					return isText ? this.BOX_SIZE / 2 : 0;
				} else if (this.type == TYPE_TABLE.Weekly) {
					return isText ? this.BOX_SIZE + (this.BOX_SIZE / 2) : this.BOX_SIZE;
				} else if (this.type == TYPE_TABLE.Monthly) {
					return isText ? this.BOX_SIZE + (this.BOX_SIZE / 2) : this.BOX_SIZE;
				}
				break;
			case 'week':
				if (this.type == TYPE_TABLE.Daily) {
					return isText ? this.BOX_SIZE + (this.BOX_SIZE / 2) : this.BOX_SIZE;
				} else if (this.type == TYPE_TABLE.Weekly) {
					return isText ? (this.BOX_SIZE * 2) + (this.BOX_SIZE / 2) : this.BOX_SIZE * 2;
				}
				break;
			case 'day':
				return isText ? (this.BOX_SIZE * 2) + (this.BOX_SIZE / 2) : this.BOX_SIZE * 2;
		}
	}

	checkBoxStart(itm, type?, property = 'real_start') {
		if (!type) {
			return itm[property] ? this.unitSize * itm[property] : 0;
		}
		// validates sunday days:
		return itm.isSunday || itm.holliday ? (itm[property] ? (this.unitSize * itm[property] + (this.unitSize / 2)) : 0)
			: (itm[property] ? this.unitSize * itm[property] : 0)
	}

	checkBoxWidth(itm, property = 'real_duration') {
		return itm[property] ? this.unitSize * itm[property] : 0;
	}

	checkBoxMiddle(itm) {
		return itm.real_middle ? this.unitSize * itm.real_middle : 0;
	}

	onContextChapterTask($event, project, phase, task, chapter) {
		let ev = {
			event: $event,
			project: project,
			phase: phase,
			task: task,
			chapter: chapter
		}
		this.contextChapterTask.emit(ev);
	}

	onContextTask($event, project, phase, task) {
		let ev = {
			event: $event,
			project: project,
			phase: phase,
			task: task
		}
		this.contextTask.emit(ev);
	}

	trackByProperty(property) {
		return function (index, item) {
			return item[property];
		}
	}

	paginateTable(type) {
		this.onPaginationTable.emit(type);
	}

	setSundayAndHolidaysDays() {
		this.days.map(day => {
			let date = this._gS.getValidDateTimezone(day.date);
			day.isSunday = date.getDay() == 0;
			day.isSaturday = date.getDay() == 6;
			return day;
		})
	}

	todayStart(itm, property = 'real_start') {
		return itm[property] ? (this.unitSize * itm[property] + (this.unitSize / 2)) : 0
	}

	setInfoForDays() {
		let today = new Date();
		this.days.map(day => {
			let date = this._gS.getValidDateTimezone(day.date);
			day.isSunday = date.getDay() == 0;
			if (this._dP.transform(date, 'yyyy-MM-dd') == this._dP.transform(today, 'yyyy-MM-dd')) {
				this.todayInfoDay = day;
			}
			return day;
		});
	}

	constructor(public _gS: GlobalService, private _dP: DatePipe, private _tS: TimelineService, private _cD: ChangeDetectorRef) { }

	ngOnInit() {
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.type || changes.projects) {
			this.calculateY();
			this.calculateYHeader();
			this.calculateViewBox();
		}
		
		if (changes.days) {
			this.setInfoForDays();
		}

		if (changes.days && this.type == TYPE_TABLE.Daily) {
			this.setSundayAndHolidaysDays();
		}
	}

}
